import { State, process } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import React, { useMemo, useState } from 'react';
import { InvalidGlCodeColumns } from 'src/assets/static/checkbook_configuration/InvalidGlCodeColumns';

import Grid from 'src/components/GridWrapper';
import { InvalidGLCodeResponseItem } from 'src/services/useGetInvalidGLCodesApi';

const initialState: State = {
  take: 10,
  skip: 0,
};

const defaultProps = {
  showColumnMenu: false,
  sortable: false,
  columns: InvalidGlCodeColumns,
  DataItemKey: 'glCdId',
};

interface InvalidGlCodeTableProps {
  dataSource: InvalidGLCodeResponseItem[];
}

const InvalidGlCodeTable: React.FC<InvalidGlCodeTableProps> = ({ dataSource }) => {
  const [dataState, setDataState] = useState(initialState);

  const { data, total } = useMemo(
    () =>
      process(dataSource, { ...dataState, sort: [{ field: 'glCode', dir: 'asc' }] }) as {
        data: InvalidGLCodeResponseItem[];
        total: number;
      },
    [dataSource, dataState]
  );

  const onDataStateChange = (event: GridDataStateChangeEvent) => {
    setDataState(event.dataState);
  };

  return (
    <>
      <div className="mt-1 mb-1">
        <Grid
          className="no_Veritcal_ScrollBar"
          style={{ maxHeight: '335px' }}
          dataSource={data}
          dataState={dataState}
          total={total}
          onDataStateChange={onDataStateChange}
          {...defaultProps}
        />
      </div>
    </>
  );
};

export default InvalidGlCodeTable;
